import { fetch2, baseURL, get } from "./api";

// 创建支付会话
export function createCheckoutSession(params: any = {}, loading: boolean = true) {
  return fetch2<string>(baseURL + "/api/pay/createCheckoutSession", params, {
    loading,
  });
}

// 创建订阅管理门户会话
export function createPortalSession(loading=true) {
  return fetch2<string>(baseURL + "/api/pay/createPortalSession", {}, {
    loading,
  });
}

// 升级或降级套餐
export function upgradeOrDegrade(params: any = {}, loading: boolean = true) {
  return fetch2(baseURL + "/api/pay/upgradeOrDegrade", params, {
    loading,
  });
}

// 获取升级或降级价格明细
export function getUpgradeOrDegradePrice(params: any = {}, loading: boolean = true) {
  return get(baseURL + "/api/pay/getUpgradeOrDegradePrice", params, {
    loading,
  });
}

// 获取弹幕支付信息
export function getBarragePayInfo(params: any = {}) {
  return get(baseURL + "/api/pay/time_sync/comment", params);
}

// 获取升级Unlimited版本费用
export function getUnlimitedPriceDiff(params: any = {}) {
  return get(baseURL + "/api/pay/getUnlimitedPriceDiff", params);
}

// 为下一账期应用取消订阅挽留优惠券
export function applyCouponNextPhase(params: any = {}) {
  return fetch2(baseURL + "/api/pay/apply/coupon/next-phase", params, {
    loading: true,
  });
}
